import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { VENDOR_VOUCHER_CREATE, VENDOR_VOUCHER_TYPES } from "../constants";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";

export const vouchersTypeApi = createApi({
  reducerPath: "vouchersTypeApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchVouchers: builder.query({
      query: ({ token }) => ({
        url: VENDOR_VOUCHER_TYPES,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useFetchVouchersQuery } = vouchersTypeApi;

export const vendorCreateApi = createApi({
  reducerPath: "vendorCreateApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchVendorCreate: builder.mutation({
      query: ({ token, payload }) => ({
        url: VENDOR_VOUCHER_CREATE,
        method: "POST",
        body: payload,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useFetchVendorCreateMutation } = vendorCreateApi;
